import styled from 'styled-components';
import { Grid, Fab, Box, Typography, TextField, Card } from '@mui/material';
import VuiBox from 'components/VuiBox';
import VuiTypography from 'components/VuiTypography';
import ButtonCustom from 'components/ButtonCustom/ButtonCustom';

export const ZeGrid = styled(Grid)`
  img {
    margin-top: 150px;
    margin-right: 90px;
    
    @media (max-width: 992px) {
      width: 100%;
      margin-top: 10px;
    }

    @media (max-width: 768px){
      display: none;
    }
  }
`

export const MainGrid = styled(Grid)`
  background-color: transparent;
  border-radius: 15px;

  @media (max-width: 992px){
    padding-left: 0;
  }

  .MuiLinearProgress-root{
    height: 6px;
  }

  .MuiLinearProgress-bar {
    height: 6px;
    top: 1.4px;
  }
`

export const BaloonGrid = styled(Grid)`
  background: #F9F9F9;
  border-radius: 5px;
  padding: 40px 30px 10px 30px;

  p {
    font-size: 16px;
  }

  h3 {
    font-size: 32px;
  }

  .greetingName {
    color: #FB8404;
  }

  && {
    margin-top: 155px;
    margin-bottom: 50px;
  }
`

export const ExplanationGrid = styled(Grid)`
  line-height: 40px;
`

export const ModalFab = styled(Fab)`
  position: fixed !important;
  bottom: 50px;
  right: 0px;
  background: linear-gradient(180deg, #FB8404 0%, #FE1E14 155.15%), #C4C4C4;
  transition: all .2s ease-in-out !important;
  margin-right: 30px !important;
    
  &:hover{
    transform: scale(1.3);
  }
`

export const RankingGrid = styled(Grid)`
  font-size: 24px;
  color: #FFFFFF;
`

export const BoardsGrid = styled(Grid)`
  justify-content: end;

  @media (max-width: 1200px) {
    justify-content: center;
  }
`

export const GraphMainContainer = styled(Grid)`
  .positive {
    color: #65EFAD;
  }
  .negative {
    color: #D7007B;
  }
  .value {
    font-size: 26px;
    font-weight: 700;
  }
  .percentage {
    font-size: 16px;
    align-self: center;
  }
  .title {
    opacity: 0.75;
    font-size: 16px;
  }
  .subtitle {
    font-size: 14px;
    opacity: 0.75;
  }
  .cardTitle {
    font-size: 18px;
    font-weight: 600;
  }
  .instagram {
    background: linear-gradient(180deg, #FB8404 0%, #FE1E14 100%);
  }
  .tiktok{
    background: linear-gradient(180deg, #F8DF00 0%, #6A4000 100%);
  }
  .twitter {
    background: linear-gradient(180deg, #00ACE2 0%, #003E52 100%)
  }
  .youtube {
    background: linear-gradient(180deg, #FF0000 0%, #5e4343 100%);
  }
  .spotify {
    background: linear-gradient(180deg, #00D554 0%, #003E52 100%); 
  }
  .emptyBar {
    background: linear-gradient(180deg, #999999 0%, #343434 100%);
  }
`

export const SocialGrid = styled(Grid)`
  border-radius: 5px;
  color: #fff;
  justify-content: center;
  text-align: center;
  padding: 5px;
  min-width: 110px;
  cursor: pointer;
`

export const SocialNameGrid = styled(Grid)`
  font-size: 15px;
  font-weight: 400;
`

export const RankingItemBox = styled(Box)`
  display: flex;
  margin-bottom: 10px;
  margin-top: 20px;
`

export const RankingName = styled(Typography)`
  color: #FFFFFF;
  font-size: 18px;
  font-weight: bold !important;
`

export const RankingInteractions = styled(Typography)`
  color: #FFFFFF;
  font-size: 16px !important;
  font-weight: bold !important;
`

export const RankingInteractionsLabel = styled(Typography)`
  color: rgba(255,255,255,0.6);
  font-size: 14px !important;
`

export const RankingChange = styled(Typography)`
  font-size: 14px !important;
  color: ${props => props.isPositive ? '#5ACC93' : '#D7007B'};
`

export const RankingPhoto = styled(Grid)`
  margin-left: ${props => props.isFirst ? '10px' : '5px'};
  position: relative;

  p {
    text-align: center;
    position: absolute;
    bottom: 35px;
    left: 7px;
  }
  .followers {
    text-align: center;
    position: absolute;
    top: 55px;
    left: 58px;
  }
  .photoContainer {
    overflow: hidden;
    border-radius: 10px;
    width: 45px;
    height: 50px;
    margin-top: 5px;

    img {
      width: 100%;
      height: 100%;
      text-align: center;
      object-fit: cover;
      color: transparent;
      text-indent: 10000px;
    }
  }
`

export const IconContainer = styled(Box)`  
  padding: 10px;
  background-color: rgba(252, 101, 8, 0.2);
  border-radius: 5px !important;
  margin-right: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  padding: 0px 12px;
  border-radius: 5px !important;
  transition: all 0.2s ease;
  position: relative;
  left: 3px;
  top: 8px;

  &:hover {
    background-color: rgba(252, 101, 8, 0.1);
    transform: scale(1.02);

    .edit-icon {
      opacity: 1;
    }

  }

  & .MuiInputLabel-root {
    color: rgba(255, 255, 255, 0.7);
  }
`

export const MembersValue = styled.span`
  color: ${props => props.isPositive ? '#5ACC93' : '#D7007B'};
  font-weight: bold;
`

export const MembersBaseline = styled.strong`
  color: ${props => props.isPositive ? '#5ACC93' : '#D7007B'};
  margin-bottom: 8px;
  width: fit-content;

  '& .MuiSelect-select': {
    paddingTop: 0,
    paddingBottom: 0,
    paddingLeft: 0,
    paddingRight: "62px !important",
    display: "flex",
    alignItems: "center"
  },
  '& .MuiSelect-icon': {
    color: "#FFFFFF",
    opacity: 0.7,
    fontSize: "28px",
    right: "4px",
    marginLeft: "10px",
    marginTop: "5px"
  },
  '&:before': {
    display: "none"
  },
  '&:after': {
    display: "none"
  },
  '&:hover:not(.Mui-disabled):before': {
    display: "none"
  }
`

export const MembersEditModal = styled(Box)`
  padding: 24px;
`

export const MembersEditTitle = styled(Typography)`
  color: #FFFFFF !important;
  margin-bottom: 24px !important;
  font-weight: bold !important;
`

export const MembersEditForm = styled(Box)`
  display: flex !important;
  flex-direction: column !important;
  gap: 24px !important;
`

export const MembersEditField = styled(Box)`
  margin-bottom: 8px !important;
`

export const MembersEditLabel = styled(Typography)`
  color: #FFFFFF !important;
  margin-bottom: 8px !important;
`

export const MembersEditTextField = styled(TextField)`
  & .MuiOutlinedInput-root {
    background-color: rgba(255, 255, 255, 0.05) !important;
    color: #FFFFFF !important;
    & fieldset {
      border-color: rgba(255, 255, 255, 0.2) !important;
    }
  }
  & .MuiInputLabel-root {
    color: rgba(255, 255, 255, 0.7) !important;
  }
`

export const MembersInfoBox = styled(Box)`
  padding: 16px !important;
  background-color: rgba(252, 101, 8, 0.1) !important;
  border-radius: 8px !important;
  border: 1px solid rgba(252, 101, 8, 0.2) !important;
`

export const MembersInfoTitle = styled(Typography)`
  color: #FC6508 !important;
  margin-bottom: 8px !important;
  font-weight: bold !important;
`

export const MembersInfoText = styled(Typography)`
  color: #FFFFFF !important;
  font-size: 12px !important;
  margin-bottom: 16px !important;
`

export const MembersInfoTip = styled(Typography)`
  color: rgba(255, 255, 255, 0.6) !important;
  font-size: 11px !important;
`

export const MembersModalActions = styled(Box)`
  display: flex !important;
  justify-content: flex-end !important;
  gap: 16px !important;
  margin-top: 32px !important;
`

export const MembersCancelButton = styled(ButtonCustom)`
  color: #FFFFFF !important;
  border-color: rgba(255, 255, 255, 0.3) !important;
  &:hover {
    border-color: #FFFFFF !important;
    background-color: rgba(255, 255, 255, 0.1) !important;
  }
`

export const MembersSaveButton = styled(ButtonCustom)`
  background-color: #FC6508 !important;
  color: #FFFFFF !important;
  &:hover {
    background-color: #e55400 !important;
  }
`

export const DashboardCard = styled(Card)`
  height: 100% !important;
  padding: 25px 22px !important;
`

export const CardContentBox = styled(VuiBox)`
  display: flex !important;
`

export const CardInfoBox = styled(VuiBox)`
  display: flex !important;
  flex-direction: column !important;
  margin-top: 10px !important;
`

export const CardProgressBox = styled(VuiBox)`
  display: flex !important;
  flex-direction: row !important;
  align-items: center !important;
  gap: 5px !important;
`

export const CardProgressText = styled(Typography)`
  font-weight: bold !important;
  font-size: 32px !important;
  line-height: 32px !important;
  color: #FFFFFF !important;
`

export const CardProgressLabel = styled(Typography)`
  font-weight: bold !important;
  font-size: 16px !important;
  color: #FFFFFF !important;
  opacity: 0.5 !important;
`

export const CardModuleText = styled(Typography)`
  font-weight: bold !important;
  font-size: 22px !important;
  color: #FFFFFF !important;
`

export const CardButtonBox = styled(VuiBox)`
  margin-top: 40px !important;
`

export const CardButtonText = styled(VuiTypography)`
  color: #FFFFFF !important;
  font-size: 16px !important;
`

export const StatusBox = styled(Box)`
  background-color: #032510;
  border-radius: 5px;
  padding: 12px 16px;
`;